import React from 'react';
import { Player, DisplayFixture, TeamInLeague } from '../../../domain/entities';

const getRatingColor = (rating: number): string => {
    if (rating >= 8) return 'var(--positive-color)';
    if (rating >= 5) return 'var(--info-color)';
    return 'var(--negative-color)';
};

interface PlayerRecentRatingsPanelProps {
    player: Player;
    last5Fixtures: DisplayFixture[];
    team: TeamInLeague;
    onSelectFixture: (fixture: DisplayFixture) => void;
}

export const PlayerRecentRatingsPanel: React.FC<PlayerRecentRatingsPanelProps> = ({ player, last5Fixtures, team, onSelectFixture }) => {
    return (
        <div className="panel">
            <div className="panel-header">Recent Ratings (last 5)</div>
            <div className="panel-content">
                {(player.recentRatings && player.recentRatings.length > 0) ? (
                    <div className="recent-ratings-list">
                        {[...player.recentRatings].reverse().map((rating, index) => {
                            const fixture = last5Fixtures[index];
                            return (
                                <button 
                                    key={index} 
                                    className="rating-badge" 
                                    style={{ backgroundColor: getRatingColor(rating) }}
                                    onClick={() => fixture && onSelectFixture(fixture)}
                                    disabled={!fixture}
                                    title={fixture ? `Vs ${fixture.home === team.name ? fixture.away : fixture.home} (W${Math.floor(fixture.week)}) - Click to view` : `Rating: ${rating.toFixed(1)}`}
                                >
                                    {rating.toFixed(1)}
                                </button>
                            )
                        })}
                    </div>
                ) : (
                    <p className="text-secondary">No recent match ratings available.</p>
                )}
            </div>
        </div>
    );
};
